import service_img1 from "./../../../assets/Home/Service_cards/service-photo1.avif";
import service_img2 from "./../../../assets/Home/Service_cards/service-photo2.avif";
import service_img3 from "./../../../assets/Home/Service_cards/service-photo3.avif";
import service_img4 from "./../../../assets/Home/Service_cards/service-photo4.avif";
import service_img5 from "./../../../assets/Home/Service_cards/service-photo5.avif";
import service_img6 from "./../../../assets/Home/Service_cards/service-photo6.avif";
import service_img7 from "./../../../assets/Home/Service_cards/service-photo7.avif";
import service_img8 from "./../../../assets/Home/Service_cards/service-photo8.avif";

const Service_cards = [
  {
    id: Math.random(),
    name: "Branding",
    desc: "Crafting visually stunning designs that will leave you speechless",
    img: `${service_img1}`,
  },
  {
    id: Math.random(),
    name: "Marketing",
    desc: "Crafting visually stunning designs that will leave you speechless",
    img: `${service_img2}`,
  },
  {
    id: Math.random(),
    name: "Web Design",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
    img: `${service_img3}`,
  },
  {
    id: Math.random(),
    name: "Pricing",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
    img: `${service_img4}`,
  },
  {
    id: Math.random(),
    name: "Classic",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
    img: `${service_img5}`,
  },
  {
    id: Math.random(),
    name: "Shopping",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
    img: `${service_img6}`,
  },
  {
    id: Math.random(),
    name: "Team1",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
    img: `${service_img7}`,
  },
  {
    id: Math.random(),
    name: "Team2",
    desc: "We'll advertise your product using latest and unique fresh marketing methods.",
    img: `${service_img8}`,
  },
];

export default Service_cards;
